import { render } from "./SalesChannelReport.vue?vue&type=template&id=7212fc10&scoped=true"
import script from "./SalesChannelReport.vue?vue&type=script&lang=js"
export * from "./SalesChannelReport.vue?vue&type=script&lang=js"

import "./SalesChannelReport.vue?vue&type=style&index=0&id=7212fc10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7212fc10"]])

export default __exports__